var map = {
	"./countdown-spacer.svg": 26,
	"./icon-active-white.svg": 27,
	"./icon-active.svg": 28,
	"./icon-arrow-right.svg": 29,
	"./icon-email.svg": 30,
	"./icon-facebook.svg": 31,
	"./icon-inactive.svg": 32,
	"./icon-instagram.svg": 33,
	"./icon-linkedin.svg": 34,
	"./icon-loader.svg": 35,
	"./icon-location.svg": 36,
	"./icon-play.svg": 37,
	"./icon-ribbon.svg": 38,
	"./icon-twitter.svg": 39,
	"./icon-video-volume.svg": 40,
	"./icon-vimeo.svg": 41,
	"./icon-whatsapp.svg": 42,
	"./icon-youtube.svg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;